import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import {pow} from 'notebook/tables/excess/util/fdlibm';

export default {
  name: 'POWER',
  category: FunctionCategory.MATH,
  shortDescription: 'A number raised to a power.',
  description: 'Returns a number raised to a power.',
  params: [
    {
      name: 'base',
      type: ArgType.number,
      description: 'The number to raise to the exponent power.',
    },
    {
      name: 'exponent',
      type: ArgType.number,
      description: 'The exponent to raise base to.',
    },
  ],

  eval: (base: number, exponent: number): number => pow(base, exponent),
} satisfies EvaluablePrimitiveSpreadsheetFunction;
